/**
 * @generated SignedSource<<1b28b8e5f400adc09931f37348245be0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountFinancialFragment$data = {
  readonly paypalDetails: any | null;
  readonly stripeDetails: any | null;
  readonly stripeRef: string | null;
  readonly " $fragmentType": "accountFinancialFragment";
};
export type accountFinancialFragment$key = {
  readonly " $data"?: accountFinancialFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountFinancialFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountFinancialFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paypalDetails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeDetails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeRef",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "8866facff51f2b716b61567832b2ebc0";

export default node;
